import React, { PureComponent } from 'react';
import { number, oneOf, string, objectOf } from 'prop-types';
import classnames from 'classnames';
import { toCommaNumber } from 'common/formatters';
import './index.css';

export default class ProgressBar extends PureComponent {
  static displayName = 'ProgressBar';

  static propTypes = {
    max: number,
    value: number,
    color: oneOf([
      'is-primary',
      'is-link',
      'is-info',
      'is-success',
      'is-warning',
      'is-danger',
    ]),
    barSize: oneOf(['is-small', 'is-medium', 'is-large']),
    unit: string,
    label: objectOf(string),
  };

  static defaultProps = {
    color: 'is-success',
    barSize: 'is-small',
    max: 8000,
    value: 4000,
    unit: null,
    label: {
      used: 'Filled',
      free: 'Free',
    },
  };

  render() {
    const { value, max, color, barSize, unit, label } = this.props;
    const progressBarClasses = classnames(color, barSize, 'progress');

    return (
      <article className={'progress__wrapper'}>
        <progress className={progressBarClasses} value={value} max={max} />
        {unit && (
          <footer className={'progress__unit'}>
            <dl>
              <dd>
                {toCommaNumber(value)} <strong>{unit}</strong>
              </dd>
              <dt>{label.used}</dt>
            </dl>
            <dl>
              <dd>
                {toCommaNumber(Number(max) - Number(value))}{' '}
                <strong>{unit}</strong>
              </dd>
              <dt>{label.free}</dt>
            </dl>
          </footer>
        )}
      </article>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ProgressBar/index.js